<template>
  <div class="animated fadeIn">
    <component :is="noCard ? 'div' : 'b-card'">
      <div v-if="!noCard" slot="header"><span>{{ $dt('project.update_title', 'Edit Project') }}</span></div>
      <div v-if="spinners.loading" class="text-center">
        <b-spinner type="grow" variant="primary" />
      </div>
      <div v-else>
        <b-form-group label-cols-md="3" :label="$dt('project.name', 'Name')" label-align-md="right"
          :invalid-feedback="fErr('name')" :state="fErrState('name')">
          <b-form-input :state="fErrState('name')" type="text" :placeholder="$dt('project.placeholder.name', 'Name')"
            disabled v-model="entity.name" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.key', 'Key')" label-align-md="right"
          :invalid-feedback="fErr('key')" :state="fErrState('key')">
          <b-form-input :state="fErrState('key')" type="text" :placeholder="$dt('project.placeholder.key', 'Key')"
            disabled v-model="entity.key" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.projectTypeKey', 'Project Type')" label-align-md="right"
          :invalid-feedback="fErr('projectTypeKey')" :state="fErrState('projectTypeKey')">
          <b-form-input :state="fErrState('projectTypeKey')" type="text"
            :placeholder="$dt('project.placeholder.projectTypeKey', 'Project Type')" disabled
            v-model="entity.projectTypeKey" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.category_id', 'Category')" label-align-md="right"
          :invalid-feedback="fErr('category_id')" :state="fErrState('category_id')">
          <b-form-select :state="fErrState('category_id')" type="text"
            :placeholder="$dt('project.placeholder.category_id', 'Category')" disabled v-model="entity.category_id"
            :options="categories" value-field="id" text-field="name" />
        </b-form-group>

        <b-form-group label-cols-md="3" :label="$dt('project.client_id', 'Client')" label-align-md="right"
          :invalid-feedback="fErr('client_id')" :state="fErrState('client_id')">
          <b-form-select :state="fErrState('client_id')" type="text"
            :placeholder="$dt('project.placeholder.client_id', 'Client')" v-model="entity.client_id" :options="clients"
            value-field="id" text-field="name" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.start_date', 'Start date')" label-align-md="right"
          :invalid-feedback="fErr('start_date')" :state="fErrState('start_date')">
          <b-form-datepicker :state="fErrState('start_date')" locale="lv" start-weekday="1"
            :placeholder="$dt('project.placeholder.start_date', 'Start date')" v-model="entity.start_date" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.end_date', 'End date')" label-align-md="right"
          :invalid-feedback="fErr('end_date')" :state="fErrState('end_date')">
          <b-form-datepicker :state="fErrState('end_date')" locale="lv" start-weekday="1"
            :placeholder="$dt('project.placeholder.end_date', 'End date')" v-model="entity.end_date" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.baseline_costs', 'Baseline cost')" label-align-md="right"
          :invalid-feedback="fErr('baseline_costs')" :state="fErrState('baseline_costs')">
          <b-input-group prepend="€">
            <b-form-input v-select-on-focus :state="fErrState('baseline_costs')" type="text"
              :placeholder="$dt('project.placeholder.baseline_costs', 'Baseline cost')" v-model="entity.baseline_costs" />
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.additional_actuals', 'Additional actuals')"
          label-align-md="right" :invalid-feedback="fErr('additional_actuals')" :state="fErrState('additional_actuals')">
          <b-input-group prepend="€">
            <b-form-input v-select-on-focus :state="fErrState('additional_actuals')" type="text"
              :placeholder="$dt('project.placeholder.additional_actuals', 'Additional actuals')"
              v-model="entity.additional_actuals" />
          </b-input-group>
        </b-form-group>
        <!-- <b-form-group label-cols-md="3" :label="$dt('project.contingency', 'Contingency')" label-align-md="right"
          :invalid-feedback="fErr('contingency')">
          <b-input-group prepend="€">
            <b-form-input type="text" :placeholder="$dt('project.placeholder.contingency', 'Contingency')"
              :class="{ 'is-invalid': fErr('contingency') }" v-model="entity.contingency" />
          </b-input-group>
        </b-form-group> -->
        <b-form-group label-cols-md="3" :label="$dt('project.contract_budget', 'Contract budget')" label-align-md="right"
          :invalid-feedback="fErr('contract_budget')" :state="fErrState('contract_budget')">
          <b-input-group prepend="€">
            <b-form-input v-select-on-focus :state="fErrState('contract_budget')" type="text"
              :placeholder="$dt('project.placeholder.contract_budget', 'Contract budget')"
              v-model="entity.contract_budget" />
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.vat_rate', 'VAT rate')" label-align-md="right"
          :invalid-feedback="fErr('vat_rate')" :state="fErrState('vat_rate')">
          <b-input-group prepend="%">
            <b-form-input v-select-on-focus :state="fErrState('vat_rate')" type="text"
              :placeholder="$dt('project.placeholder.vat_rate', 'VAT rate')" v-model="entity.vat_rate" />
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.profit_margin_goal', 'Profit Margin Goal')"
          label-align-md="right" :invalid-feedback="fErr('profit_margin_goal')" :state="fErrState('profit_margin_goal')">
          <b-input-group prepend="%">
            <b-form-input v-select-on-focus :state="fErrState('profit_margin_goal')" type="text"
              :placeholder="$dt('project.placeholder.profit_margin_goal', 'Profit Margin Goal')"
              v-model="entity.profit_margin_goal" />
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.payment_due_days', 'Payment due days')"
          label-align-md="right" :invalid-feedback="fErr('payment_due_days')" :state="fErrState('payment_due_days')">
          <b-form-input v-select-on-focus :state="fErrState('payment_due_days')" type="text"
            :placeholder="$dt('project.placeholder.payment_due_days', 'Payment due days')"
            v-model="entity.payment_due_days" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.estimated_completition', 'Estimated completition')"
          label-align-md="right" :invalid-feedback="fErr('estimated_completition')"
          :state="fErrState('estimated_completition')">
          <b-input-group prepend="%">
            <b-form-input v-select-on-focus type="text" :state="fErrState('estimated_completition')"
              :placeholder="$dt('project.placeholder.estimated_completition', 'Estimated completition')"
              v-model="entity.estimated_completition" />
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.estimated_end_date', 'Estimated end date')"
          label-align-md="right" :invalid-feedback="fErr('estimated_end_date')" :state="fErrState('estimated_end_date')">
          <b-form-datepicker :state="fErrState('estimated_end_date')" locale="lv" start-weekday="1"
            :placeholder="$dt('project.placeholder.estimated_end_date', 'Estimated end date')" :reset-button="true"
            :reset-value="null" v-model="entity.estimated_end_date" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.reference_start_date', 'Reference start date')"
          label-align-md="right" :invalid-feedback="fErr('reference_start_date')"
          :state="fErrState('reference_start_date')">
          <b-form-datepicker :state="fErrState('reference_start_date')" locale="lv" start-weekday="1"
            :placeholder="$dt('project.placeholder.reference_start_date', 'Reference start date')" :reset-button="true"
            :reset-value="null" v-model="entity.reference_start_date" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.reference_end_date', 'Reference end date')"
          label-align-md="right" :invalid-feedback="fErr('reference_end_date')"
          :state="fErrState('reference_end_date')">
          <b-form-datepicker :state="fErrState('reference_end_date')" locale="lv" end-weekday="1"
            :placeholder="$dt('project.placeholder.reference_end_date', 'Reference end date')" :reset-button="true"
            :reset-value="null" v-model="entity.reference_end_date" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.contract_id', 'Contract number')" label-align-md="right"
          :invalid-feedback="fErr('contract_id')" :state="fErrState('contract_id')">
          <b-form-input v-select-on-focus :state="fErrState('contract_id')" type="text"
            :placeholder="$dt('project.placeholder.contract_id', 'Contract number')" v-model="entity.contract_id" />
        </b-form-group>
        <b-form-group label-cols-md="3" :label="$dt('project.auto_update', 'Auto update start/end dates')"
          label-align-md="right" :invalid-feedback="fErr('auto_update')" :state="fErrState('auto_update')">
          <b-form-checkbox :state="fErrState('auto_update')" type="text" v-model="entity.auto_update" />
        </b-form-group>

      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small />
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Projects' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </component>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import { mapGetters, mapActions } from 'vuex';
import Services from '@/services/index';
import VT from '@/store/types';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        loading: false,
        isSaving: false,
      },
      clients: [],
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    jira_key: { type: String, required: true }, // if project
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() { return {}; },
    },
    noCard: { type: [Boolean], default: false },
  },
  components: {
  },
  computed: {
    ...mapGetters('JiraProjects', ['projectCategories']),
    categories() { return Object.values(this.projectCategories); },
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
  },
  methods: {
    load() {
      this.spinners.loading = true;
      const requests = [Services.clients.all(), Services.projects.editData(this.jira_key)];
      Promise.all(requests).then(([clients, { data }]) => {
        this.clients = clients.data.data;
        this.spinners.loading = false;
        this.entity = this.isUpdateForm ? data.project : { ...this.entity, ...data.project };
      }).catch((data) => {
        console.warn(data);
        this.spinners.loading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      Services.projects.update(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped></style>
